import { render, staticRenderFns } from "./getUuser.vue?vue&type=template&id=5c60c030&scoped=true&"
import script from "./getUuser.vue?vue&type=script&lang=js&"
export * from "./getUuser.vue?vue&type=script&lang=js&"
import style0 from "./getUuser.vue?vue&type=style&index=0&id=5c60c030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60c030",
  null
  
)

export default component.exports